import { Button, ButtonProps, Link, LinkProps } from "@chakra-ui/react";

type LinkButtonProps = Pick<LinkProps, "href"> & ButtonProps;

export default function LinkButton({ href, children, ...rest }: LinkButtonProps) {
  return (
    <Link href={href} isExternal>
      <Button cursor="pointer" {...rest}>
        {children}
      </Button>
    </Link>
  );
}
